import { handleGetSinglePop } from 'redux/actions/pops'
import { INotification, INotificationActionHandler } from 'services/notifications/types'

const getString = (value: unknown): string | null => {
  if (typeof value !== 'string') return null
  const trimmed = value.trim()
  return trimmed || null
}

const getPopId = (notification: INotification): string | null => {
  const objectRef = notification.object_ref ?? notification.data?.object_ref ?? null
  return getString(
    objectRef?.pop_id ??
      objectRef?.id ??
      notification.data?.pop_id ??
      notification.data?.id ??
      (notification as any).pop_id
  )
}

const getPopType = (notification: INotification): number | null => {
  const objectRef = notification.object_ref ?? notification.data?.object_ref ?? null
  const popType = Number(objectRef?.pop_type ?? notification.data?.pop_type)

  return Number.isFinite(popType) ? popType : null
}

export const popsResolver: INotificationActionHandler = {
  id: 'pops',
  service: 'pops',
  async resolve(notification, { dispatch }) {
    const popId = getPopId(notification)

    if (popId) {
      await dispatch?.(
        handleGetSinglePop(popId, {
          showPlaceholder: true,
          title: notification.title,
          body: notification.body,
          popType: getPopType(notification),
        })
      )
    }

    return { handled: true }
  },
}
